import { compact } from "lodash-es";
import { ensureArray } from "./array";

const sattrRegexp = /^(\w+)(?:<(\w+)>)?\((.*)\)$/;

function splitArgs(value: string) {
  let arg = "",
    count = 0;

  const args = []; // TODO trim update paul

  for (let i = 0; i < value.length; ++i) {
    const char = value[i];

    if (char == "(") {
      ++count;
    }

    if (char == ")") {
      --count;
    }

    if (i == value.length - 1 && char != ",") {
      arg += char;

      args.push(arg);
    } else if (count == 0 && char == ",") {
      args.push(arg);

      arg = "";
    } else arg += char;
  }

  return args.map((arg) => arg.trim());
}

export function createSattr(options: {
  key: string;
  flag?: string;
  args: string[];
  minify?: boolean;
}) {
  return compact([
    options.key,
    options.flag && `<${options.flag}>`,
    `(${options.args.join(options.minify ? "," : ", ")})`,
  ]).join("");
}

export type Sattr = {
  key: string;
  flag: string;
  args: string[];
  arg: string | undefined;
};

export function parseSattr(
  attr: string,
  allowedKey?: string | readonly string[],
  allowedFlag?: string | readonly string[]
) {
  const values = sattrRegexp.exec(attr);

  if (!values) {
    return null;
  }

  const args = splitArgs(values[3]);

  const sattr: Sattr = {
    key: values[1],
    flag: values[2],
    args,
    arg: args[0],
  };

  const allowedKeys = allowedKey && ensureArray(allowedKey);

  if (
    allowedKeys &&
    allowedKeys.length > 0 &&
    !allowedKeys.includes(sattr.key)
  ) {
    return null;
  }

  const allowedFlags = allowedFlag && ensureArray(allowedFlag);

  if (
    allowedFlags &&
    allowedFlags.length > 0 &&
    !allowedFlags.includes(sattr.flag)
  ) {
    return null;
  }

  return sattr;
}
